var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5417 24.5417V10.3334H6.45833V24.5417H24.5417ZM20.6667 1.29175H23.25V3.87508H24.5417C25.2268 3.87508 25.8839 4.14725 26.3684 4.63172C26.8528 5.11619 27.125 5.77327 27.125 6.45841V24.5417C27.125 25.9755 25.9754 27.1251 24.5417 27.1251H6.45833C5.77319 27.1251 5.11611 26.8529 4.63164 26.3684C4.14717 25.884 3.875 25.2269 3.875 24.5417V6.45841C3.875 5.02466 5.02458 3.87508 6.45833 3.87508H7.75V1.29175H10.3333V3.87508H20.6667V1.29175ZM14.2083 12.2709H16.7917V16.1459H20.6667V18.7292H16.7917V22.6042H14.2083V18.7292H10.3333V16.1459H14.2083V12.2709Z",
    fill: "#13A859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAdd);
export default __webpack_public_path__ + "static/media/calendar-add.6e5bf1c7ecb672d7545dca5f4797d45a.svg";
export { ForwardRef as ReactComponent };